import styled from "styled-components"

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.banner.text};
  border-radius: 8px;
`

export const AccordionItem = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`

export const AccordionHeading = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`

export const AccordionHeadingOuter = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 22px;
`

export const AccordionToggle = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 24px;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  transition: transform 0.3s;

  ${({ rotated }) => (rotated ? "transform: rotate(180deg);" : "")}
`

export const AccordionPanel = styled.div`
  ${({ show }) => (show ? "display: block;" : "display: none;")}

  font-size: 16px;
  padding: 0 22px 20px;
`
